module.exports = __webpack_public_path__ + "images/301610d476cd3f888f591f82f8d9f554-xpo-pro_and_trav-pro.png";